import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login'
import NoAccess from '../pages/NoAccess'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/no-access',
    name: 'NoAccess',
    component: NoAccess
  },
]

const router = new VueRouter({
  routes
})

export default router
